import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://api.odonto-bot.cl";

export default function ListadoVideos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState("");

  const cargarVideos = async () => {
    try {
      setLoading(true);
      setMensaje("");

      const response = await axios.get(`${API_URL}/videos`);

      if (response.data?.ok) {
        setVideos(response.data.videos || []);
      } else {
        setMensaje("No se pudieron cargar los videos.");
      }
    } catch (error) {
      console.error("Error al cargar videos:", error);
      setMensaje("Error al cargar los videos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarVideos();
  }, []);

  const handleVerVideo = (video) => {
    window.open(`${API_URL}${video.play_url}`, "_blank");
  };

  const handleDescargarVideo = (video) => {
    window.open(`${API_URL}${video.download_url}`, "_blank");
  };

  const handleEliminarVideo = async (video) => {
    const confirmar = window.confirm(
      `¿Seguro que deseas eliminar el video "${video.nombre}"?\n\nEsta acción eliminará el video y sus fragmentos asociados.`
    );

    if (!confirmar) return;

    try {
      await axios.delete(`${API_URL}/videos/${video.id}`);

      setVideos((prevVideos) =>
        prevVideos.filter((item) => item.id !== video.id)
      );

      setMensaje("Video eliminado correctamente.");
    } catch (error) {
      console.error("Error al eliminar video:", error);
      setMensaje(error.response?.data?.error || "Error al eliminar el video.");
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return "-";

    return new Date(fecha).toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  if (loading) {
    return <p style={styles.loading}>Cargando videos...</p>;
  }

  return (
    <div>
      {mensaje && <p style={styles.message}>{mensaje}</p>}

      {videos.length === 0 ? (
        <p style={styles.empty}>No hay videos cargados.</p>
      ) : (
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Nombre</th>
                <th style={styles.th}>Subido por</th>
                <th style={styles.th}>Tema</th>
                <th style={styles.th}>Fecha</th>
                <th style={styles.th}>Tamaño</th>
                <th style={styles.th}>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {videos.map((video, index) => (
                <tr key={video.id} style={styles.tr}>
                  <td style={styles.td}>
                    {index + 1}. {video.nombre}
                  </td>

                  <td style={styles.td}>
                    {video.subido_por || "Admin"}
                  </td>

                  <td style={styles.td}>
                    {video.tema ? video.tema : "Sin tema"}
                  </td>

                  <td style={styles.td}>
                    {formatearFecha(video.creado_en)}
                  </td>

                  <td style={styles.td}>
                    {video.tamano || "0 MB"}
                  </td>

                  <td style={styles.actionsTd}>
                    <button
                      type="button"
                      style={styles.viewBtn}
                      onClick={() => handleVerVideo(video)}
                    >
                      Ver
                    </button>

                    <button
                      type="button"
                      style={styles.downloadBtn}
                      onClick={() => handleDescargarVideo(video)}
                    >
                      Descargar
                    </button>

                    <button
                      type="button"
                      style={styles.deleteBtn}
                      onClick={() => handleEliminarVideo(video)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const styles = {
  loading: {
    fontSize: 14,
    color: "#374151",
  },

  empty: {
    fontSize: 14,
    color: "#6B7280",
  },

  message: {
    marginBottom: 12,
    fontSize: 14,
    color: "#0033A0",
    fontWeight: 500,
  },

  tableWrapper: {
    width: "100%",
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 14,
  },

  th: {
    backgroundColor: "#0033A0",
    color: "#FFFFFF",
    padding: "12px 14px",
    textAlign: "left",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },

  tr: {
    borderBottom: "1px solid #E5E7EB",
  },

  td: {
    padding: "12px 14px",
    color: "#111827",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },

  actionsTd: {
    padding: "12px 14px",
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },

  viewBtn: {
    backgroundColor: "#2563EB",
    color: "#FFFFFF",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
  },

  downloadBtn: {
    backgroundColor: "#059669",
    color: "#FFFFFF",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
  },

  deleteBtn: {
    backgroundColor: "#E6002D",
    color: "#FFFFFF",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
  },
};